import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import renderHTML from 'react-render-html';
// import SearchBar from '../common/SearchBar';

import ProductsSiteSearch from './ProductsSiteSearch';
import CategoriesSiteSearch from './CategoriesSiteSearch';
// import SupportSiteSearch from './SupportSiteSearch';
import SearchNotFound from '../notFound/SearchNotFound';
import UrlSiteSearch from './UrlSiteSearch';
import LinkToStore from '../notFound/LinkToStore';

class SiteSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			keyword: null,
			products: [],
			categories: [],
			moreInfo: null
		};
	}

	componentWillMount() {
		this.setState({
			products: this.props.products
		});
		this.setState({
			categories: this.props.categories
		});
		this.setState({
			moreInfo: this.props.moreInfo
		});
		this.setState({
			urls: this.props.urls
		})
	}

	populateStoreProducts(keyword) {
		return <SearchNotFound keyword={keyword} />;
	}

	render() {

		//This is the image url to the Shopify store menu image
		let defaultImageUrl = "https://cdn.shopify.com/s/files/1/0610/5982/5850/files/SentrySafe_Store_logo_250x@2x.png?v=1648577760";

		//Below are the values to alternate to.
		//target should be _blank or _self
		let compareTerms = [
			{
				"terms": ["desic", "dessic"],
				"name": "SentrySafe Approved Desiccant – Two 40 gram Packs P50200",
				"image": "https://cdn.shopify.com/s/files/1/0610/5982/5850/products/P50200_1080x.png?v=1681833876",
				"url": "https://store.sentrysafe.com/collections/accessories/products/p50200",
				"target": "_blank"
			},
			{
				"terms": ["accesso"],
				"name": "",
				"image": "",
				"url": "https://store.sentrysafe.com/collections/safe-accessories",
				"target": "_blank"
			}
		];

		let products;
		let categories;
		let urls;
		// let support;
		const keyword = this.props.keyword !== undefined ? this.props.keyword : this.state.keyword;

		if (keyword === '') {
			return (
				<section className="section section-search-results no-results">
					<div className="section-content row">
						<div className="col">
							<h1 className="section-title">Search</h1>
							<p>
								To search our safe products,
								please enter a search term above.
							</p>
						</div>
					</div>
				</section>
			);
		}

		if (!this.props.count || this.props.count < 1) {

			const compareTerm = keyword.toLowerCase();
			let searchMatch = null;
			compareTerms.map(ct => {
				let terms = ct.terms;

				for (var t = 0; t < terms.length; t++) {
					let cTerm = terms[t].toLowerCase();
					if (compareTerm.startsWith(cTerm)) {
						searchMatch = ct;
					}
				}
			});
			if (searchMatch) {
				let img = defaultImageUrl;
				if (searchMatch.image) {
					img = searchMatch.image;
				}
				let product = {
					name: searchMatch.name,
					image: img,
					url: searchMatch.url,
					target: searchMatch.target
				}
				return <LinkToStore product={product} keyword={keyword} />;
			} else {
				return <SearchNotFound keyword={keyword} />;
			}
		}

		// console.dir(this.state.urls);
		if (this.state.urls !== undefined && this.state.urls.length > 0) {
			const uLink = this.state.urls.map(
				(url, index) => <UrlSiteSearch key={index} url={url} />
			);
			urls = (
				<ul className="results-list">
					{uLink}
				</ul>
			)
		}

		if (this.state.products !== undefined && this.state.products.length > 0) {
			const product = this.state.products.map(
				(product, index) => <ProductsSiteSearch key={index} product={product} />
			);
			products = (
				<ul className="results-list">
					{product}
				</ul>
			);
		}

		if (this.state.categories !== undefined && this.state.categories.length > 0) {
			const category = this.state.categories.map(
				(category, index) => <CategoriesSiteSearch key={index} category={category} />
			);
			categories = (
				<ul className="results-list">
					{category}
				</ul>
			);
		}

		// if (this.state.moreInfo !== undefined && this.state.moreInfo !== null) {
		// 	const serviceSupport = <SupportSiteSearch moreInfo={ this.state.moreInfo } />;
		// 	support = (
		// 		<ul className="results-list">
		// 			{ serviceSupport }
		// 		</ul>
		// 	);
		// }

		return (
			<div className="search-results">
				<Helmet
					title={renderHTML(`Search Results for "${keyword}" &#124; SentrySafe`)}
					meta={[
						{
							property: 'description',
							content: 'Use search to find information you need about our products.'
						}
					]}
				/>

				<section className="section section-search-results">
					<div className="row">
						<div className="col">
							{/*<div className="search-bar-container">
								<SearchBar />
							</div>*/}
							<h1 className="section-title">
								<b>{this.props.count}</b> {this.props.count === 1 ? 'Result' : 'Results'} for &ldquo;{keyword}&rdquo;
							</h1>
							{urls}
							{products}
							{categories}
							{/* support */}
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	token: ['token'],
	keyword: ['siteSearch', 'keyword'],
	count: ['siteSearch', 'totalCount'],
	products: ['siteSearch', 'products'],
	categories: ['siteSearch', 'categories'],
	moreInfo: ['siteSearch', 'moreInfo'],
	urls: ['siteSearch', 'urls']
}, SiteSearch);


// WEBPACK FOOTER //
// ./src/pages/sitesearch/SiteSearch.js